<template>
    <div class="strategy_main" v-if="bigCat5Strategy != null" style="background-color: #275ba9">
        <div id="navigation_title" v-if="!isWeixinBrowser()" class="navigation" :style="{height:getNavCount()+'px'}">
            <div :style="{height:getStateHeight()+'px'}"></div>
            <div class="left" @click="goBack"><img src="@/Images/icon_white_back.png"/></div>
            <div class="title">拓展补充</div>
            <div class="clear"></div>
        </div>

        <div v-if="!isWeixinBrowser()" :style="{'padding-top':getNavCount()+'px'}"></div>
        <div v-if="!isEmpty(bigCat5Strategy.text)" class='video_text'><pre>{{bigCat5Strategy.text}}</pre></div>

        <div class="video_all" v-if="!isEmpty(bigCat5Strategy.video)">
            <div class="video_lines">
                <div class="num">1</div>
                <div class="title" v-html="bigCat5Strategy.videoLines"></div>
            </div>

            <div class='video_content'>
                <video-player class="video-player vjs-custom-skin"
                              ref="videoPlayer"
                              :playsinline="true"
                              :options="playerOptions">
                </video-player>
            </div>

            <div class="video_text3"></div>
        </div>

        <div class="strategy_picture">
            <div class="group_img" v-for="(item,index) in bigCat5Strategy.listPicture" :key="index">
                <div class="num">{{(!isEmpty(bigCat5Strategy.video) ? (index + 1) : index) + 1}}</div>
                <div class="title" v-html="item.title"></div>
                <img :src="$qiNiuDomainBase + item.fileName" />
                <div class="group_text">长按保存图片</div>
            </div>
        </div>

        <div class="strategy_book" v-if="!isEmpty(bigCat5Strategy.listBook)">
            <div class="title">推荐阅读</div>
            <div class="books">
                <div class="book" v-for="(book,index) in bigCat5Strategy.listBook" :key="index" @click="bookClick(book.pk)">
                    <img :src="getWholeThumbnailCut(book.fileName, 180, 240)" alt="" />
                </div>
            </div>
        </div>

        <div class="bottom"></div>

    </div>
</template>

<script>
    import { videoPlayer } from 'vue-video-player'
    import 'vue-video-player/src/custom-theme.css'
    import 'video.js/dist/video-js.css'

    export default {
        components: {
            videoPlayer
        },
        data() {
            return {
                lessonId: 0,
                bigCat5Strategy: null,
                imgSrc: '',
                fromPage: 0,
                playerOptions: {
                    //播放速度
                    playbackRates: [0.5, 1.0, 1.5, 2.0],
                    //如果true,浏览器准备好时开始回放。
                    autoplay: false,
                    // 默认情况下将会消除任何音频。
                    muted: false,
                    // 导致视频一结束就重新开始。
                    loop: false,
                    // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    preload: 'auto',
                    language: 'zh-CN',
                    // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    aspectRatio: '16:9',
                    // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    fluid: true,
                    sources: [{
                        //类型
                        type: "video/mp4",
                        //url地址
                        src: ''
                    }],
                    //你的封面地址
                    poster: '',
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    notSupportedMessage: '此视频暂无法播放，请稍后再试',
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        //全屏按钮
                        fullscreenToggle: true
                    }
                }
            }
        },
        methods: {
            getStateHeight: function () {
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            goBack: function () {
                this.$router.go(this.fromPage === 1 ? -2 : -1);
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            stopOtherAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:stopOtherAudio";
                }

                if (vPlatform === 4) {
                    window.note.stopOtherAudio();
                }
            },
            bookClick: function (pk) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:enterBook:" + pk;
                }

                if (vPlatform === 4) {
                    window.note.enterBook(pk);
                }
            }
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(this.$route.query.lessonId);
            let vFromPage = parseInt(that.$route.query.fromPage);
            let url = "englishProgram/getExpansionSupplementInfo/" + vLessonId;
            this.$axios.get(url).then((response) => {
                that.lessonId = vLessonId;
                that.fromPage = vFromPage;
                that.bigCat5Strategy = response.data;

                if (!that.isEmpty(that.bigCat5Strategy.video)) {
                    that.stopOtherAudio();

                    let vedioUrl = that.$qiNiuDomainBase + that.bigCat5Strategy.video;
                    that.playerOptions.poster = vedioUrl + "?vframe/jpg/offset/5";
                    that.playerOptions.sources[0].src = vedioUrl;
                }

                if (!that.isWeixinBrowser()) {
                    that.$nextTick(() => {
                        $(window).scroll(function () {
                            var scrollTop = parseFloat(parseFloat($(window).scrollTop()));

                            if (scrollTop > 44) {
                                $("#navigation_title").removeClass("navigation");
                                $("#navigation_title").addClass("navigation_white");
                            } else {
                                $("#navigation_title").removeClass("navigation_white");
                                $("#navigation_title").addClass("navigation");
                            }
                        });
                    });
                }
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        activated() {
            window.scrollTo(0, 0);
        }
    }
</script>

<style scoped>

    .left img {
        width: 30px;
        height: 30px;
        margin-top: 9px;
    }

    .video_all {
        margin-left: 20px;
        margin-right: 20px;
    }

    .video_text_right {
        float: right;
    }
    .video_text2 {
        background-color: white;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 40px;
        padding: 15px;
        line-height: 25px;
        font-size: 11pt;
        color: #333333;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }

    .video_text3 {
        margin-bottom: 50px;
    }

    .video_text {
        background-color: white;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 40px;
        margin-bottom: 50px;
        padding: 15px;
        line-height: 25px;
        font-size: 11pt;
        color: #333333;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        text-align: left;
    }

    .video_text pre {
        white-space: pre-wrap; /* css-3 */
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: pre-wrap; /* Opera 4-6 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
    }

    .strategy_main {
        position: absolute;
        width: 100%;
        height: auto;
        min-height: 100%;
        text-align: center;
    }

    .video_content {
        display: inline-block;
        width: 100%;
        height: auto;
        text-align: center;
        line-height: 100px;
        overflow: hidden;
        background: #fff;
        position: relative;
    }

    .knowledge_title {
        width: 100%;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        color: white;
        padding-left: 15px;
        padding-right: 15px;
        margin-top: 20px;
    }

    .knowledge_content {
        width: 100%;
        font-size: 17px;
        text-align: left;
        color: white;
        padding-left: 15px;
        padding-right: 15px;
        margin-top: 10px;
    }

    .gold_split {
        width: 100%;
        height: 10px;
        background-color: rgba(255, 176, 0, 0.7);
        margin-top: 30px;
        margin-bottom: 30px;
    }

    .structure_title {
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        line-height: 30px;
        color: white;
        padding-left: 15px;
        padding-right: 15px;
        margin-bottom: 10px;
    }

    .structure_title span {
        font-size: 15px;
        color: white;
        line-height: 30px;
        vertical-align: middle;
    }

    .video_content:hover {
        display: block;
    }

    .strategy_book {
        width: calc(100% - 40px);
        height: auto;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 30px;
        z-index: 997;
        margin-bottom: 30px;
    }

    .strategy_book .title {
        background-color: #FEB800;
        color: white;
        font-size: 17px;
        font-weight: bold;
        text-align: center;
        display: inline-block;
        width: 100px;
        height: 35px;
        line-height: 35px;
        padding: 2px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }

    .strategy_book .books {
        width: 100%;
        font-size: 0;
        margin-top: -17.5px;
        margin-bottom: 15px;
        padding: 45px 9px 10px 9px;
        background-color: rgba(0,0,0,0.4);
        border-radius: 8px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }

    .strategy_book .books .book {
        width: calc((100vmin - 120px)/3 + 20px);
    }

    .strategy_book .books img {
        width: calc((100vmin - 120px)/3);
        height: calc((400vmin - 480px)/9);
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 20px;
    }


    .strategy_picture {
        position: relative;
        width: 100%;
        z-index: 997;
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
    }

    .group_img {
        width: 100%;
        height: auto;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 30px;
        z-index: 997;
        margin-bottom: 30px;
    }

    .group_text {
        margin-top: 3px;
        font-size: 10pt;
        color: white;
    }

    .video_lines .num, .group_img .num {
        background-color: #FEB800;
        color: white;
        font-size: 20px;font-weight: bold;
        display: inline-block;
        width: 35px;
        height: 35px;
        line-height: 35px;
        border-radius: 17.5px;
        -webkit-border-radius: 17.5px;
        -moz-border-radius: 17.5px;
    }

    .group_img img {
        width: 100%;
        height: auto;
        background-color: white;
    }

    .video_lines {
        margin-top: 30px;
    }

    .video_lines .title, .group_img .title {
        width: 100%;
        font-size: 15px;
        margin-top: -17.5px;
        margin-bottom: 15px;
        padding: 30px 15px 30px 15px;
        color: white;
        background-color: rgba(0,0,0,0.4);
        border-radius: 8px;
        text-align: left;
    }

    .bottom {
        height: 100px;
    }

    .video_title {
        position: relative;
        display: inline-block;
        font-size: 20px;
        font-weight: bold;
        margin-top: 30px;
        margin-bottom: 20px;
        color: white;
        text-align: center;
    }

    .left_line {
        position: absolute;
        width: 40px;
        height: 1px;
        background-color: #f4f4f4;
        top: 50%;
        -webkit-transform: translateY(-50%);
    }

    .title_back {
        width: 150px;
        height: 36px;
        background-color: #fda228;
        -webkit-border-radius: 18px;
        -moz-border-radius: 18px;
        margin-left: 50px;
        margin-right: 50px;
        text-align: center;
    }

    .title_back span {
        font-size: 16px;
        font-weight: bold;
        line-height: 36px;
    }

    .right_line {
        position: absolute;
        width: 40px;
        height: 1px;
        margin-left: 210px;
        background-color: #f4f4f4;
        top: 50%;
        -webkit-transform: translateY(-50%);
    }

    .first_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(85, 85, 85, 0.96);
        z-index: 99999;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .first_content {
        position:relative;
    }

    .first_transition .first_content img {
        position: absolute;
        width: 79px;
        top: -50px;
        right: 20px;
    }

    .first_transition .first_content .content {
        background-color: #fef67e;
        width: calc(100vmin - 40px);
        padding: 30px 20px 20px 20px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
        -moz-border-radius: 15px;
        border: 3px solid rgba(0, 0, 0, 1);
        text-align: left;
    }

    .first_transition .first_content .content .text {
        font-size: 16px;
        color: #101010;
    }
</style>
